module.exports = __webpack_public_path__ + "img/mortgage-protection-hands.bd3afb3.png";